import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirecting
import "../components/AllBrand.css";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import Navbar from "../components/Navbar";

function Ecatalog() {
  const [ecatalog, setEcatalog] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const fetchEcatalog = async () => {
      try {
        setLoading(true);
        const ecatalogResponse = await apiClient.get("/ecatalog");
        setEcatalog(ecatalogResponse.data);
      } catch (err) {
        setError("Failed to fetch Ecatalog data");
      } finally {
        setLoading(false);
      }
    };

    fetchEcatalog();
  }, []);

  // const handleImageClick = (fileUrl) => {
  //   navigate("/viewer-pdf", { state: { fileUrl } });
  // };

  const handleImageClick = (fileUrl) => {
    window.open(fileUrl, "_blank"); // Opens PDF in a new tab
  };

  return (
    <>
    <Navbar/>
      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          minHeight: "100vh",
        }}
      > */}
      <div className="flex flex-col items-center justify-center text-center px-4 py-16 md:py-24">
        {loading && <p>Loading Brands...</p>}
        {error && <p>{error}</p>}

        <h5 className="mt-16 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
          E-Brochure
        </h5>

        {ecatalog.length > 0 && (
          // <div className="grid-container">
          <div className="w-full md:w-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-32 mt-8">
            {ecatalog.map((item) => (
              <div
                className="brand-card h-20 md:h-full cursor-pointer md:bg-transparent"
                key={item.id}
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="brand-image w-full h-48 object-cover md:scale-150"
                  onClick={() => handleImageClick(item.file[0])} // Pass the PDF file URL
                />
                <p>{item.name}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer></Footer>
    </>
  );
}

export default Ecatalog;
